import styled from '@emotion/styled'

const Section = styled.div`
  min-height: 80vh;
  position: relative;
  padding-top: 2rem;
`

export default Section
